import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import ChecklistItem from 'components/checklist/ChecklistItem';
import PropTypes from 'prop-types';

import RenderChecklistPages from './RenderChecklistPages';

// eslint-disable-next-line import/order
import 'components/checklist/Checklist.scss';
import './PagesChecklist.scss';

export default class PagesChecklist extends Component {
  static propTypes = {
    items: PropTypes.array,
    className: PropTypes.string,
    checklistId: PropTypes.string
  };

  state = {
    items: []
  };

  static defaultProps = {
    items: [],
    className: '',
    checklistId: ''
  };

  componentDidMount() {
    const { items } = this.props;

    this.setState({ items });
  }

  componentDidUpdate(prevProps) {
    const { items } = this.props;

    if (items.length !== prevProps.items.length) {
      this.setState({ items });
    }
  }

  getIcon(type) {
    const contentType = 'CONTENT';
    const icons = {
      content: 'icon-content',
      quiz: 'icon-quiz'
    };

    return type === contentType ? icons.content : icons.quiz;
  }

  get itemsShowed() {
    const { items } = this.state;

    return JSON.parse(JSON.stringify(items)).filter((item) => {
      if (item.show) {
        item.pages = item.pages.filter((page) => page.show);
      }

      return item.show;
    });
  }

  renderChecklistModule = (item, index) => {
    const { checklistId } = this.props;

    const key = `checklist__${checklistId}__item__${index}`;

    return (
      <Fragment key={key}>
        <ChecklistItem
          {...this.props}
          id={key}
          item={item}
          className="checklist__item__module"
        />
        <RenderChecklistPages
          {...this.props}
          index={index}
          getIcon={this.getIcon}
          checklistId={checklistId}
          pages={item.pages}
        />
      </Fragment>
    );
  };

  render() {
    const { className } = this.props;

    const classComponent = classNames('checklist', className);

    return (
      <ul className={classComponent}>
        {this.itemsShowed.map(this.renderChecklistModule)}
      </ul>
    );
  }
}
